import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ElementsService {
  private _status$ = new BehaviorSubject<boolean>(false);
  public get status$(): Observable<any> {
    return this._status$.asObservable();
  }

  public changeStatus(status: boolean) {
    this._status$.next(status);
  }
}
